import React, { useState, useMemo } from 'react';
import moment from 'moment';
import { Divider, Card, Row, Col, DatePicker, notification } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { dateToString, shouldUpdateCompare } from 'utils/utils2';
import Button from 'components/Button';
import Title from 'components/Title';
import ThirdPartyInput from 'components/ThirdPartyInput';
import MGListByUser from 'components/MgListByUser';
import { runCollection } from 'services/collection';
import { useQuery } from 'react-query';
import JobResult from 'pages/Accounting/Components/JobResult';

const initialSearchParams: any = {
  tpidstart: 0,
  tpidend: 1000000,
  duedate: moment() as any,
  mgid: Number(localStorage.getItem('mgid')),
};

const RunCollection = () => {
  const [form] = useForm();
  const [searchParams, setSearchParams] = useState<any>(initialSearchParams);
  const [exec, setExec] = useState<boolean>(false);

  const params = useMemo(
    () => ({
      ...searchParams,
      tpidstart: form.getFieldValue('tpidstart'),
      tpidend:
        form.getFieldValue('tpidend')?.tpid ?? form.getFieldValue('tpidstart'),
      duedate: dateToString(searchParams.duedate),
      mgid: form.getFieldValue('mgid'),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParams]
  );

  const onFinish = (values: any) => {
    setSearchParams((prev: any) => ({
      ...prev,
      ...values,
    }));
    setTimeout(refetch, 0);
  };

  const {
    data: jobResponse,
    refetch,
    isFetching,
  } = useQuery(
    ['runCollection', params],
    () =>
      runCollection({
        ...params,
        tpidend: params.tpidend === 0 ? 1000000 : params.tpidend,
      }).then((res) => {
        if (res.code === '200') {
          notification.success({
            message: res.message,
            description: res.description,
          });
        }
        return res;
      }),
    {
      enabled: false,
    }
  );

  return (
    <DF.Provider pagcode="runcollection">
      <Card
        title={<Title level={4} comcode="runcollection"></Title>}
        size="small"
      >
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={initialSearchParams}
        >
          <br></br>
          <Row gutter={30}>
            <FormInput col xs={24} md={8} name="mgid">
              <MGListByUser userid={Number(localStorage.getItem('userid'))} />
            </FormInput>
            <FormInput col xs={24} md={8} name="tpidstart">
              <ThirdPartyInput
                onlytpid
                onSelected={(e: any) => {
                  form.setFieldsValue({ tpidend: e });
                }}
              />
            </FormInput>
            <FormInput
              col
              xs={24}
              md={8}
              name="tpidend"
              shouldUpdate={shouldUpdateCompare('tpidstart')}
            >
              <ThirdPartyInput onlytpid />
            </FormInput>
            <FormInput col xs={24} md={8} name="duedate">
              <DatePicker showToday />
            </FormInput>

            <Col xs={24} md={8} lg={6}>
              <Button
                loading={isFetching}
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ alignContent: 'center' }} xs={24}>
              {isFetching && (
                <Title level={3} type="danger" comcode="pleasewait" />
              )}
            </Col>
          </Row>
        </Form>
        <Divider></Divider>
        <br />
        <br />

        <JobResult jobResponse={jobResponse} entity="COLLECTION" />
      </Card>
    </DF.Provider>
  );
};

export default RunCollection;
